import FileUploader from './js/file_uploader'
// import FilePreview from './js/file_uploader'



frappe.provide('frappe.ui');

frappe.ui.FileUploader = FileUploader
// frappe.ui.FilePreview = FilePreview